import styled, { OverHeading, Huge, px } from "livemap-ui";

import { Membership } from "../api/person";
import { chevronRight } from "../icons";

export interface MembershipCardDispatch {
  onClick?(): void;
}

export interface MembershipCardProps {
  membership: Membership;
}

type Props = MembershipCardProps & MembershipCardDispatch;

export function MembershipCard({ membership, onClick }: Props) {
  return (
    <Card onClick={onClick}>
      <Huge size="smaller">{membership.organization.name}</Huge>
      <OverHeading>
        Joined {new Date(membership.joinedAt).toLocaleDateString()}
      </OverHeading>
      {chevronRight}
    </Card>
  );
}

const Card = styled.div`
  padding: ${px(12, 6)};
  border-bottom: 1px solid ${(p) => p.theme.borderColor};
  cursor: pointer;
  position: relative;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &:active {
    color: ${(p) => p.theme.detailColor};
  }

  > svg {
    opacity: ${(p) => p.theme.disabledOpacity};
    position: absolute;
    right: ${px(12)};
    top: ${px(23)};
    width: ${px(24)};
    height: ${px(24)};
  }
`;
